import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { RefactorRegularModal } from "../../../../components/dialog";
import styles from "./ChartZoomModal.module.scss";

interface ChartZoomModalProps {
    children: ReactNode;
    title?: string;
    isOpen: boolean;
    onClose: () => void;
}

const ChartZoomModal = ({ children, title, isOpen, onClose }: ChartZoomModalProps) => {
    const { t } = useTranslation();
    const [shouldRenderChart, setShouldRenderChart] = useState(false);

    // 延遲渲染圖表，確保 Modal DOM 完全準備好
    useEffect(() => {
        if (isOpen) {
            // 使用多重延遲確保 DOM 完全準備好
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const timer1 = requestAnimationFrame(() => {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const timer2 = requestAnimationFrame(() => {
                    setTimeout(() => {
                        setShouldRenderChart(true);
                    }, 100);
                });
            });
            return () => {
                setShouldRenderChart(false);
            };
        } else {
            setShouldRenderChart(false);
        }
    }, [isOpen]);

    return (
        <RefactorRegularModal>
            <RefactorRegularModal.Container
                width='90vw'
                maxHeight='90vh'
                enableScrolling={false}
                onClose={onClose}
                props={{
                    open: isOpen,
                    onClose: onClose,
                }}
            >
                <div className={styles.modalHeader}>
                    <RefactorRegularModal.Title>
                        {title ? t(title) : t("ANALYSIS.Chart_Zoom")}
                    </RefactorRegularModal.Title>
                    <button className={styles.closeButton} onClick={onClose} aria-label={t("COMMON.Close") || ""}>
                        ×
                    </button>
                </div>
                <RefactorRegularModal.Content>
                    <div className={styles.chartWrapper}>
                        {shouldRenderChart ? (
                            children
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    fontSize: "16px",
                                    color: "#666",
                                }}
                            >
                                載入中...
                            </div>
                        )}
                    </div>
                </RefactorRegularModal.Content>
            </RefactorRegularModal.Container>
        </RefactorRegularModal>
    );
};

export default ChartZoomModal;
